import { Menu as MenuAntd, MenuItemProps } from 'antd';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const TabMenu = styled(MenuAntd)`
  border: none;
  background-color: ${COLOR.ALABASTER};
  line-height: 35px;
  margin-bottom: 40px;
`;

TabMenu.defaultProps = {
  mode: 'horizontal',
};

type TabItemStyledProps = {
  $isRead?: boolean;
};

export const TabItemStyled = styled(MenuAntd.Item)<TabItemStyledProps>`
  &&&.ant-menu-item {
    color: ${COLOR.OUTER_SPACE};
    font-size: 14px;
    a {
      color: ${COLOR.OUTER_SPACE};
    }
    &.hasNotification:before {
      content: '';
      height: 6px;
      width: 6px;
      background-color: ${({ $isRead }) => ($isRead ? COLOR.IRON : COLOR.CHEMISTRY)};
      border-radius: 50%;
      display: 'inline-block';
      margin-right: 10px;
      position: absolute;
      top: calc(50% - 3px);
      left: 10px;
    }

    &:first-child:not(.hasNotification) {
      padding-left: 0px;
      &:after {
        left: 0px;
      }
    }
  }
  &&&.ant-menu-item-selected {
    color: ${COLOR.OUTER_SPACE};
    font-weight: bold;
    &::before {
      background-color: ${COLOR.CHEMISTRY};
    }
  }
`;

type TabItemProps = MenuItemProps & {
  $hasNotification?: boolean;
  $isRead?: boolean;
  children?: React.ReactNode;
};

export const TabItem = ({ $hasNotification, children, ...props }: TabItemProps) => {
  return (
    <TabItemStyled {...props} className={$hasNotification ? 'hasNotification' : ''}>
      {children}
    </TabItemStyled>
  );
};
